import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function ExitDoor({
  position = [-24.75, -0.08, -49.67],
  rotation = [0, 0, 0],
  scale = 1,
  children,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/exitdoor.glb");
  const exitDoorScene = useMemo(() => scene.clone(true), [scene]);

  useEffect(() => {
    exitDoorScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [exitDoorScene]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={exitDoorScene} />
        {children}
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/exitdoor.glb");
